import type { AxiosRequestConfig } from 'axios';
import { authStateManager } from '@/infra/auth/AuthStateManager';
import { logger } from '@/infra/logging';

export async function queueDuringAuthInit(config: AxiosRequestConfig): Promise<AxiosRequestConfig> {
  const authEndpoints = ['/auth/login', '/auth/logout', '/auth/me'];
  const isAuthEndpoint = authEndpoints.some(endpoint => config.url?.includes(endpoint));

  if (isAuthEndpoint) {
    return config;
  }

  if (!authStateManager.isInitialized()) {
    logger.debug('Request queued until auth initialization completes', {
      component: 'ApiClient.RequestInterceptor',
      url: config.url,
    });

    await authStateManager.waitForAuthInit();

    logger.debug('Request resumed after auth initialization', {
      component: 'ApiClient.RequestInterceptor',
      url: config.url,
    });
  }

  return config;
}
